export const numberColumn = (value: any, formatStr: string) => {
  if (value === null || value === undefined || value === '') return '';

  if (formatStr === ',.2f') {
    return `${Number(value)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }

  if (formatStr === ',.6f') {
    const formatted = Number(value).toFixed(6);
    const parts = formatted.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const decimalPart = parts[1];

    return `${integerPart}.${decimalPart}`;
  }

  if (formatStr === '.2f') return Number(value).toFixed(2);
  if (formatStr === '.0f') return Math.round(Number(value)).toString();

  return value.toString();
};
